module.exports = {
  arc:    require('./arc'),
  area:   require('./area'),
  group:  require('./group'),
  image:  require('./image'),
  line:   require('./line'),
  path:   require('./path'),
  rect:   require('./rect'),
  rule:   require('./rule'),
  symbol: require('./symbol'),
  text:   require('./text')
};



//////////////////
// WEBPACK FOOTER
// ./~/vega-scenegraph/src/render/canvas/marks/index.js
// module id = 246
// module chunks = 0